import { render, staticRenderFns } from "./CreateSecondaryUserDialog.vue?vue&type=template&id=25ff1338&"
import script from "./CreateSecondaryUserDialog.vue?vue&type=script&lang=js&"
export * from "./CreateSecondaryUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports